import script from "./PricingSingleBox.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingSingleBox.vue?vue&type=script&setup=true&lang=js"

import "./PricingSingleBox.vue?vue&type=style&index=0&id=78bdb0a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78bdb0a0"]])

export default __exports__